import { toPairs } from 'ramda';
import { debounce } from 'underscore';

const loadedScripts = [];

export const getScript = (src, { callbackParam, queryParams = {}, cache = true } = {}) =>
    new Promise((resolve, reject) => {
        const callbackName = `cb_${String(Math.random()).replace(/\./g, '')}`;
        const script = document.createElement('script');
        const url = new window.URL(src, location.origin);
        const clear = () => {
            script.remove();
            delete window[callbackName];
        };

        toPairs(queryParams)
            .forEach(pair => url.searchParams.append(...pair));

        if (loadedScripts.includes(url.href)) {
            resolve();
            return;
        }

        // in most cases scripts should be cached,
        // except rare cases, when you need to request data every time,
        // therefore cache equals true by default
        if (cache) {
            loadedScripts.push(url.href);
        }

        const onLoad = (response) => {
            resolve(response);
            clear();
        };

        const onError = () => {
            reject(new Error(`Script "${url.href}" loading error.`));
            clear();
        };

        // this property may be useful when:
        // - requesting data with JSONP
        // - many js api provide mechanism waiting their initialization/load by putting callback parameter
        if (callbackParam) {
            url.searchParams.append(callbackParam, callbackName);
            window[callbackName] = onLoad;
        } else {
            script.onload = onLoad;
        }

        script.src = url.href;
        script.onerror = onError;
        document.body.appendChild(script);
    });

export const scaleRecaptcha = (recaptchaContainer) => {
    let storedHeight = '';

    if (!recaptchaContainer?.firstElementChild) {
        return;
    }

    const setStyles = (ratio) => {
        if (!ratio) {
            storedHeight = recaptchaContainer.firstElementChild.style.height;
            recaptchaContainer.firstElementChild.style.height = '';
        } else {
            recaptchaContainer.firstElementChild.style.height = storedHeight;
        }
        recaptchaContainer.firstElementChild.style.transform = ratio ? `scale(${ratio})` : '';
        recaptchaContainer.firstElementChild.style.transformOrigin = ratio ? '0 0' : '';
        recaptchaContainer.style.height = ratio ? `${Math.ceil(containerHeight * ratio)}px` : '';
    };
    // reset each time for get origin sizes
    setStyles();

    const { offsetWidth: containerWidth, offsetHeight: containerHeight } = recaptchaContainer;
    const { offsetWidth: captchaWidth = 304 } = recaptchaContainer.firstElementChild;

    if (captchaWidth > containerWidth) {
        setStyles(containerWidth / captchaWidth);
    }
};

export const addCaptchaChallengeClass = debounce(() => {
    const iFrameList = document.querySelectorAll('iframe');
    const captchaChallengeFrame = [...iFrameList].find(
        frame => frame.src.includes('google.com/recaptcha/api2/bframe')
    );

    if (captchaChallengeFrame) {
        captchaChallengeFrame.parentElement.classList.add('captcha-challenge-container');
    }
}, 2000);
